import { render, staticRenderFns } from "./yipi.vue?vue&type=template&id=51cfa47e&scoped=true&"
import script from "./yipi.vue?vue&type=script&lang=js&"
export * from "./yipi.vue?vue&type=script&lang=js&"
import style0 from "./yipi.vue?vue&type=style&index=0&id=51cfa47e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cfa47e",
  null
  
)

export default component.exports